import React from 'react';
import styles from './styles.module.scss';
import { ProductType } from '../../types';
import { trackAppDownloadClick } from '../../utils/tracking';

interface SuccessSlideProps {
  productType: ProductType;
  zipFlag: boolean | null;
  mongoId?: string;
  phone?: string;
}

/**
 * Slide di successo dopo l'invio del form
 */
const SuccessSlide: React.FC<SuccessSlideProps> = ({
  productType,
  zipFlag,
  mongoId,
  phone,
}) => {

  const handleAppDownloadClick = () => {
    trackAppDownloadClick();
  };


  const steps = [
    { emoji: '📞', text: 'Entro 24h ti chiamiamo per confermare i dettagli' },
    { emoji: '📊', text: 'Ricevi il tuo preventivo personalizzato completo' },
    { emoji: '📅', text: 'Fissiamo un sopralluogo tecnico gratuito' },
    { emoji: '⚡', text: 'Installazione in 30 giorni e inizi subito a risparmiare' },
  ];

  return (
    <div className={styles.successSlide}>
      <div className={styles.successHeader}>
        <div className={styles.successIcon}>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" fill="#22c55e" />
            <path
              d="M8 12l2.5 2.5L16 9"
              stroke="#fff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      <h3 className={styles.successMainTitle}>
        Perfetto! La tua richiesta è stata inviata
      </h3>

      <p className={styles.successSubtitle}>
        Cosa succede ora?
      </p>

      <div className={styles.stepsBox}>
        {steps.map((step, index) => (
          <div key={index} className={styles.stepItem}>
            <span className={styles.stepEmoji}>{step.emoji}</span>
            <span className={styles.stepText}>{step.text}</span>
          </div>
        ))}
      </div>

      {mongoId && (
        <a
          href={`https://app.enpal.it/login?payload=${btoa(phone || '')}`}
          className={styles.appCta}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleAppDownloadClick}
        >
          Scarica l'app per scoprire di più sui bonus
        </a>
      )}
    </div>
  );
};

export default SuccessSlide;
